import { SSE } from 'sse.js'

const fetchStream = (method, url, data, onStart, onUpdate, onError, onClose) => {
  const params = JSON.stringify(data)
  let source = new SSE(url, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('cbaas_system_Token')}`,
      'Content-Type': 'application/json'
    },
    payload: params,
    method: method
  })

  source.addEventListener('open', function(e) {
    onStart && onStart()
  })

  source.addEventListener('message', function(e) {
    let data = e.data ? JSON.parse(e.data): {}
    onUpdate && onUpdate(data)
  })

  source.addEventListener('error', function(e) {
    let errInfo = e.data ? JSON.parse(e.data): {}
    onError && onError(errInfo)
  })

  source.addEventListener('close', function(e) {
    onClose && onClose()
  })

  source.stream()
}

export { fetchStream }
